import { StrictMode, useState, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './styles/globals.css'
import App from './App'
import CdCDetailPage from './components/casa-della-comunita/CdCDetailPage'
import CaseDellaComunitaPage from './components/casa-della-comunita/CaseDellaComunitaPage'
import PianiDiZonaPage from './components/piani-di-zona/PianiDiZonaPage'
import PdzDetailPage from './components/piani-di-zona/PdzDetailPage'
import PoloTerritorialePage from './components/polo-territoriale/PoloTerritorialePage'
import PptDetailPage from './components/polo-territoriale/PptDetailPage'
import StruttureSanitariePage from './components/strutture-sanitarie/StruttureSanitariePage'
import FarmaciePage from './components/farmacie/FarmaciePage'
import FarmaciaDetailPage from './components/farmacie/FarmaciaDetailPage'
import StrutturaAsstDetailPage from './components/strutture-sanitarie/StrutturaAsstDetailPage'
import RsaPage from './components/rsa/RsaPage'
import RsaDetailPage from './components/rsa/RsaDetailPage'
import CdiPage from './components/cdi/CdiPage'
import CdiDetailPage2 from './components/cdi/CdiDetailPage2'
import RsdPage from './components/rsd/RsdPage'
import CssPageNew from './components/css/CssPageNew'
import CddPage from './components/cdd/CddPage'
import NewsPage from './components/NewsPage'
import ReferendumPage from './components/referendum/ReferendumPage'
import DashboardPage from './components/DashboardPage'
import CardsPage from './components/CardsPage'
import HomePage from './components/HomePage'

import DisabilitaDetailPage from './components/DisabilitaDetailPage'
import AuthPage from './components/AuthPage'
import ProfilePage from './components/ProfilePage'
import { Header } from './components/Header'
import SideMenu from './components/SideMenu'

function DetailLayout({ children }: { children: React.ReactNode }) {
  const [sideMenuOpen, setSideMenuOpen] = useState(false)
  const [theme, setTheme] = useState<'dark' | 'light'>(() =>
    (typeof window !== 'undefined' && document.documentElement.getAttribute('data-theme') as 'light' | 'dark') || 'light'
  )
  useEffect(() => { document.documentElement.setAttribute('data-theme', theme) }, [theme])
  return (
    <div className="app">
      <Header onMenuOpen={() => setSideMenuOpen(true)} />
      <SideMenu
        open={sideMenuOpen}
        onClose={() => setSideMenuOpen(false)}
        theme={theme}
        onToggleTheme={() => setTheme(prev => prev === 'dark' ? 'light' : 'dark')}
      />
      {children}
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/profilo" element={<ProfilePage />} />
        <Route path="/datidemografici" element={<App />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/casedellacomunita" element={<CaseDellaComunitaPage />} />
        <Route path="/pianidizona" element={<PianiDiZonaPage />} />
        <Route path="/poloterritoriale" element={<PoloTerritorialePage />} />
        <Route path="/poloterritoriale/:slug" element={<DetailLayout><PptDetailPage /></DetailLayout>} />
        <Route path="/strutturesanitarie" element={<StruttureSanitariePage />} />
        <Route path="/farmacie" element={<FarmaciePage />} />
        <Route path="/farmacie/:slug" element={<DetailLayout><FarmaciaDetailPage /></DetailLayout>} />
        <Route path="/struttureasst/:slug" element={<DetailLayout><StrutturaAsstDetailPage /></DetailLayout>} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/referendum" element={<ReferendumPage />} />
        <Route path="/cards" element={<CardsPage />} />
        <Route path="/rsa" element={<RsaPage />} />
        <Route path="/cdi" element={<CdiPage />} />
        <Route path="/rsd" element={<RsdPage />} />
        <Route path="/css" element={<CssPageNew />} />
        <Route path="/cdd" element={<CddPage />} />
        <Route path="/rsa/:slug" element={<DetailLayout><RsaDetailPage /></DetailLayout>} />
        <Route path="/rsd/:slug" element={<DetailLayout><DisabilitaDetailPage prefix="rsd" /></DetailLayout>} />
        <Route path="/css/:slug" element={<DetailLayout><DisabilitaDetailPage prefix="css" /></DetailLayout>} />
        <Route path="/cdd/:slug" element={<DetailLayout><DisabilitaDetailPage prefix="cdd" /></DetailLayout>} />
        <Route path="/cdi/:slug" element={<DetailLayout><CdiDetailPage2 /></DetailLayout>} />
        
        <Route path="/casadellacomunita/:slug" element={<DetailLayout><CdCDetailPage /></DetailLayout>} />
        <Route path="/pianodizona/:ambito/:slug" element={<DetailLayout><PdzDetailPage /></DetailLayout>} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
